import { graphql, useStaticQuery } from "gatsby"

export const UseEALinks = () => {
    const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
            youTube_EA_ProxyBrushVid,
            youTube_EA_ProxyBrushThumb,
            youTube_EA_OralHygieneVid,
            youTube_EA_OralHygieneThumb,
            youTube_EA_RetainerCareVid,
            youTube_EA_RetainerCareThumb,
            youTube_EA_PokeyWireVid,
            youTube_EA_PokeyWireThumb
          }
      }
    }
  `)

    return data.site.siteMetadata
}